const types = {
  GET_TRANSACTION_HISTORY_ADVERTISER: 'GET_TRANSACTION_HISTORY_ADVERTISER',
  GET_TRANSACTION_HISTORY_BLOGGER: 'GET_TRANSACTION_HISTORY_BLOGGER',
  GET_ADVERTISEMENT_BUDGET: 'GET_ADVERTISEMENT_BUDGET',
  GET_BLOGGER_BUDGET: 'GET_BLOGGER_BUDGET',
  ERRORS_WITHDRAWAL: 'ERRORS_WITHDRAWAL',
  ERROR_REFILL: 'ERROR_REFILL',
};
export default types;
